import { createSelector } from 'reselect';
import { getUsersState } from 'src/modules/users/selectors/getUsersState';

export const getUserDeleting = createSelector([
  getUsersState,
], (state) => state.deleting);
